import * as React from "react";

function SvgRight(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M0 0v16h16V0H0zm13 13H3V3h10v10z" opacity={0.06} fill="#555d63" /><path d="M13 12.2V3.8l2.3-2.2c.3-.2.7-.1.7.2v12.4c0 .3-.3.4-.7.2L13 12.2z" fill="#555d63" /></svg>;
}

export default SvgRight;